import * as XLSX from 'xlsx/xlsx.mjs';
import { Message } from 'element-ui';

function downloadFile(fileName, blobData) {
  const link = document.createElement('a');
  document.body.appendChild(link);
  link.download = fileName;
  link.href = URL.createObjectURL(blobData);
  link.click();

  setTimeout(function () { //延时释放，过短可能导致部分浏览器下载被中断
    URL.revokeObjectURL(link.href); //用URL.revokeObjectURL()来释放这个object URL
  }, 1000);
}

function s2ab(s) { //字符串转字符流
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
  return buf;
}

// 将 0 起始的列索引转换为 Excel 列名（26 进制）。映射关系：[0-25] -> [A-Z]，26 -> [AA]。
function getCharCol(n) {
  let s = '';
  for (n++; n > 0; n = Math.floor((n - 1) / 26)) {
    s = String.fromCharCode((n - 1) % 26 + 65) + s;
  }
  return s;
}

export default function exportExcel(list, fileName = '列表', type = 'xlsx') {
  if (!list.length) return Message({
    message: '暂无数据可以导出',
    type: 'info',
    duration: 5000,
  });

  const tmpList = list.slice(); //拷贝一份，避免 unshift 修改调用方传入的数组
  const tmpData = tmpList[0]; //先取第一条数据行用于提取列名（须在插入表头之前）
  tmpList.unshift({});
  const keyMap = []; //获取keys
  //keyMap =Object.keys(list[0]);
  for (let k in tmpData) {
    if (!tmpData.hasOwnProperty(k)) continue;
    keyMap.push(k);
    tmpList[0][k] = k;
  }

  const rowMap = {};//用来保存转换好的json
  tmpList.map((v, i) => keyMap.map((k, j) => Object.assign({}, {
    v: v[k],
    position: getCharCol(j) + (i + 1)
  }))).reduce((prev, next) => prev.concat(next)).forEach((v) => rowMap[v.position] = {
    v: v.v
  });

  const outputPos = Object.keys(rowMap); //设置区域,比如表格从A1到D10
  const tmpWB = {
    SheetNames: ['mySheet'], //保存的表标题
    Sheets: {
      'mySheet': Object.assign({},
        rowMap, //内容
        {
          '!ref': outputPos[0] + ':' + outputPos[outputPos.length - 1] //设置填充区域
        })
    }
  };

  // 文件名去除系统非法字符，避免下载失败
  const safeFileName = String(fileName).replace(/[\\/:*?"<>|]/g, '_');

  const blobData = new Blob([s2ab(XLSX.write(tmpWB,
    { bookType: type, bookSST: false, type: 'binary' }//这里的数据是用来定义导出的格式类型
  ))], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  }); //创建二进制对象写入转换好的字节流
  downloadFile(`${safeFileName}.${type}`, blobData);
}
